import { createSlice, current } from '@reduxjs/toolkit';
import { createExpense, updateExpense, getExpenses, deleteExpenses } from '../../thunks/admin/expenses';
import { mergeArrayByKey } from '../../../utils/helpers/data';

export const expensesSlice = createSlice({
  name: 'expenses',
  initialState: {
    expenses: [],
    currentPage: 1,
    limit: 30,
    totalDocs: 0,

    isCreating: false,
    isUpdating: {},
    isFetching: false,
  },

  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    }
  },

  extraReducers: {
    [getExpenses.pending]: (state, action) => {
      state.isFetching = true;
    },
    [getExpenses.fulfilled]: (state, action) => {
      const { expenses, totalDocs } = action.payload;

      state.totalDocs = totalDocs;
      
      const currentState = current(state);
      state.expenses = currentState.currentPage === 1 ? [...expenses] : mergeArrayByKey([...currentState.expenses, ...expenses], '_id');
    
      state.isFetching = false;
    },
    [getExpenses.rejected]: (state, action) => {
      const currentState = current(state);
      if (currentState.currentPage === 1) {
        state.expenses = [];
        state.totalDocs = 0;
      }
      state.isFetching = false;
    },
    
    [createExpense.pending]: (state, action) => {
      state.isCreating = true;
    },
    [createExpense.fulfilled]: (state, action) => {
      const currentState = current(state);
      state.expenses.push(action.payload);
      state.totalDocs = currentState.totalDocs + 1;
      state.currentPage = Math.trunc(currentState.totalDocs / currentState.limit) + 1;
      state.isCreating = false;
    },
    [createExpense.rejected]: (state, action) => {
      state.isCreating = false;
    },

    [updateExpense.pending]: (state, action) => {
      state.isUpdating[action.meta.arg.formData._id] = true;
    },
    [updateExpense.fulfilled]: (state, action) => {
      const currentState = current(state);
      const updatedExpense = action.payload;
      state.expenses = currentState.expenses.map(expense => expense._id === updatedExpense._id ? updatedExpense : expense);
      state.isUpdating[updatedExpense._id] = false;
    },
    [updateExpense.rejected]: (state, action) => {
      state.isUpdating[action.meta.arg.formData._id] = false;
    },

    [deleteExpenses.fulfilled]: (state, action) => {
      const currentState = current(state);
      const ids = action.payload;
      state.expenses = currentState.expenses.filter(({ _id }) => !ids.includes(_id));
      state.totalDocs = currentState.totalDocs - ids.length;
      state.currentPage = Math.trunc(currentState.totalDocs / currentState.limit) + 1;
    }
  }
});

export const { setCurrentPage } = expensesSlice.actions;

export default expensesSlice.reducer;
